/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConnectionNode,
    ConnectionNodeFromJSON,
    ConnectionNodeFromJSONTyped,
    ConnectionNodeToJSON,
    WorkspaceConnectionStatus,
    WorkspaceConnectionStatusFromJSON,
    WorkspaceConnectionStatusFromJSONTyped,
    WorkspaceConnectionStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkspaceConnection
 */
export interface WorkspaceConnection {
    /**
     * The unique identifier for the connection.
     * @type {string}
     * @memberof WorkspaceConnection
     */
    connectionId: string;
    /**
     * 
     * @type {ConnectionNode}
     * @memberof WorkspaceConnection
     */
    inviter?: ConnectionNode;
    /**
     * 
     * @type {ConnectionNode}
     * @memberof WorkspaceConnection
     */
    invitee?: ConnectionNode;
    /**
     * The time the connection was confirmed
     * @type {Date}
     * @memberof WorkspaceConnection
     */
    connectedAt?: Date;
    /**
     * The status of the ticket.
     * @type {string}
     * @memberof WorkspaceConnection
     */
    status: WorkspaceConnectionStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum WorkspaceConnectionStatusEnum {
    Pending = 'PENDING',
    Approved = 'APPROVED',
    Confirmed = 'CONFIRMED',
    Rejected = 'REJECTED',
    Revoked = 'REVOKED',
    Expired = 'EXPIRED'
}

export function WorkspaceConnectionFromJSON(json: any): WorkspaceConnection {
    return WorkspaceConnectionFromJSONTyped(json, false);
}

export function WorkspaceConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceConnection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'connectionId': json['connectionId'],
        'inviter': !exists(json, 'inviter') ? undefined : ConnectionNodeFromJSON(json['inviter']),
        'invitee': !exists(json, 'invitee') ? undefined : ConnectionNodeFromJSON(json['invitee']),
        'connectedAt': !exists(json, 'connectedAt') ? undefined : (new Date(json['connectedAt'])),
        'status': json['status'],
    };
}

export function WorkspaceConnectionToJSON(value?: WorkspaceConnection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'connectionId': value.connectionId,
        'inviter': ConnectionNodeToJSON(value.inviter),
        'invitee': ConnectionNodeToJSON(value.invitee),
        'connectedAt': value.connectedAt === undefined ? undefined : (value.connectedAt.toISOString()),
        'status': value.status,
    };
}


